import { FilterObject } from './filter-object';

export class SubPropertyContainsFilter extends FilterObject<any> {

  public filter(itemToFiltre: any): boolean {
    return this.doFilter(itemToFiltre, this.field, this.values);
  }

  public doFilter(itemToFiltre: any, field: any, value: any): boolean {
    if (value == null) {
      return true;
    }
    let fieldToCheck: string = field[0];
    let innerField: string = field[1];

    let result = false;
    let lignes = itemToFiltre[fieldToCheck];
    lignes.forEach((ligne: any) => {
      let typeModif = ligne[innerField];
      result = result || value.indexOf(typeModif) != -1;
    });
    return result;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/subproperty-contains.filter.ts